import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Step,
  StepLabel,
  Stepper,
  Button,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const steps = [
  "Select campaign settings",
  "Create an ad group",
  "Create an ad",
];

const HorizontalStepper = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Horizontal stepper
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          Horizontal steppers are ideal when the contents of one step depend on
          an earlier step.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "  const [activeStep, setActiveStep] = React.useState(0);\n" +
              "  const [skipped, setSkipped] = React.useState(new Set());\n" +
              "\n" +
              "  const isStepOptional = (step) => {\n" +
              "    return step === 1;\n" +
              "  };\n" +
              "\n" +
              "  const isStepSkipped = (step) => {\n" +
              "    return skipped.has(step);\n" +
              "  };\n" +
              "\n" +
              "  const handleNext = () => {\n" +
              "    let newSkipped = skipped;\n" +
              "    if (isStepSkipped(activeStep)) {\n" +
              "      newSkipped = new Set(newSkipped.values());\n" +
              "      newSkipped.delete(activeStep);\n" +
              "    }\n" +
              "\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep + 1);\n" +
              "    setSkipped(newSkipped);\n" +
              "  };\n" +
              "\n" +
              "  const handleBack = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep - 1);\n" +
              "  };\n" +
              "\n" +
              "  const handleSkip = () => {\n" +
              "    if (!isStepOptional(activeStep)) {\n" +
              "      // You probably want to guard against something like this,\n" +
              "      // it should never occur unless someone's actively trying to break something.\n" +
              "      throw new Error(\"You can't skip a step that isn't optional.\");\n" +
              "    }\n" +
              "\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep + 1);\n" +
              "    setSkipped((prevSkipped) => {\n" +
              "      const newSkipped = new Set(prevSkipped.values());\n" +
              "      newSkipped.add(activeStep);\n" +
              "      return newSkipped;\n" +
              "    });\n" +
              "  };\n" +
              "\n" +
              "  const handleReset = () => {\n" +
              "    setActiveStep(0);\n" +
              "  };\n              " +
              "" +
              "" +
              "" +
              "<Stepper activeStep={activeStep}>\n" +
              "                {steps.map((label, index) => {\n" +
              "                  const stepProps = {};\n" +
              "                  const labelProps = {};\n" +
              "                  if (isStepOptional(index)) {\n" +
              "                    labelProps.optional = (\n" +
              '                      <Typography variant="caption">Optional</Typography>\n' +
              "                    );\n" +
              "                  }\n" +
              "                  if (isStepSkipped(index)) {\n" +
              "                    stepProps.completed = false;\n" +
              "                  }\n" +
              "                  return (\n" +
              "                    <Step key={label} {...stepProps}>\n" +
              "                      <StepLabel {...labelProps}>{label}</StepLabel>\n" +
              "                    </Step>\n" +
              "                  );\n" +
              "                })}\n" +
              "              </Stepper>\n" +
              "              {activeStep === steps.length ? (\n" +
              "                <React.Fragment>\n" +
              "                  <Typography sx={{ mt: 2, mb: 1 }}>\n" +
              "                    All steps completed - you&apos;re finished\n" +
              "                  </Typography>\n" +
              '                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>\n' +
              '                    <Box sx={{ flex: "1 1 auto" }} />\n' +
              "                    <Button onClick={handleReset}>Reset</Button>\n" +
              "                  </Box>\n" +
              "                </React.Fragment>\n" +
              "              ) : (\n" +
              "                <React.Fragment>\n" +
              "                  <Typography sx={{ mt: 2, mb: 1 }}>\n" +
              "                    Step {activeStep + 1}\n" +
              "                  </Typography>\n" +
              '                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>\n' +
              "                    <Button\n" +
              '                      color="inherit"\n' +
              "                      disabled={activeStep === 0}\n" +
              "                      onClick={handleBack}\n" +
              "                      sx={{ mr: 1 }}\n" +
              "                    >\n" +
              "                      Back\n" +
              "                    </Button>\n" +
              '                    <Box sx={{ flex: "1 1 auto" }} />\n' +
              "                    {isStepOptional(activeStep) && (\n" +
              "                      <Button\n" +
              '                        color="inherit"\n' +
              "                        onClick={handleSkip}\n" +
              "                        sx={{ mr: 1 }}\n" +
              "                      >\n" +
              "                        Skip\n" +
              "                      </Button>\n" +
              "                    )}\n" +
              "\n" +
              "                    <Button onClick={handleNext}>\n" +
              '                      {activeStep === steps.length - 1 ? "Finish" : "Next"}\n' +
              "                    </Button>\n" +
              "                  </Box>\n" +
              "                </React.Fragment>\n" +
              "              )}"
            }
          >
            <Box sx={{ width: "100%" }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography variant="caption">Optional</Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {activeStep === steps.length ? (
                <React.Fragment>
                  <Typography sx={{ mt: 2, mb: 1 }}>
                    All steps completed - you&apos;re finished
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button onClick={handleReset}>Reset</Button>
                  </Box>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Typography sx={{ mt: 2, mb: 1 }}>
                    Step {activeStep + 1}
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                    >
                      Back
                    </Button>
                    <Box sx={{ flex: "1 1 auto" }} />
                    {isStepOptional(activeStep) && (
                      <Button
                        color="inherit"
                        onClick={handleSkip}
                        sx={{ mr: 1 }}
                      >
                        Skip
                      </Button>
                    )}

                    <Button onClick={handleNext}>
                      {activeStep === steps.length - 1 ? "Finish" : "Next"}
                    </Button>
                  </Box>
                </React.Fragment>
              )}
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default HorizontalStepper;
